import React, { useEffect, useContext, useState } from 'react';
import { Link ,useNavigate } from 'react-router-dom';
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import axios from 'axios';
import {cleanStr,cleanPass} from '../../comfunc.js';
import {strEncode,strDecode} from '../../encrpt.js';
import DataTable from 'react-data-table-component';
import DatePicker from "react-datepicker"; // Ensure you install react-datepicker
import '../Raportee/datatable.css';
import {API_BASE_URL} from "../../apiConfig.jsx";
import FileUpload from "./file-upload/file-upload.component.jsx";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

function Predefined() {
	const navigate = useNavigate();
	useEffect(() => {
		const authToken = localStorage.getItem("authToken");

		if (!authToken) {
			localStorage.removeItem("user"); // Clear user data
			navigate(""); // Ensure correct redirection path
		}
	}, [navigate]);

	  const [categories, setCategories] = useState([]);
	  const [subcategories, setSubcategories] = useState([]);
	  const [selectedCategory, setSelectedCategory] = useState("");
	  const [subcat, setSubCat] = useState("");
	  const [columns, setColumns] = useState([]);
	  const [tabledata, settableData] = useState([]);	
	
	  useEffect(() => {
		axios.post(`${API_BASE_URL}/api/custom/selectall`,
		{ t: strEncode('pmis_predefined_reports'), cols: strEncode("DISTINCT(c_type) as type") })
		  .then((response) => setCategories(response.data))
		  .catch((error) => console.error("Error fetching categories:", error));
	  }, []);
	
   
	  useEffect(() => {
		if (subcat) {
			axios.post(`${API_BASE_URL}/api/predefined`, {
				sql: strEncode(subcat)				
			})
			.then((res) => {
				const columnKeys = Object.keys(res.data.data[0]);					
				const formattedColumns = columnKeys.map((key) => ({
					name: key.charAt(0).toUpperCase() + key.slice(1),
					selector: row => row[key],
					sortable: true,
					cell: (row) => 
					   row[key] // Show normal column data
				  }));
				//console.log("columnKeys",columnKeys)
				setColumns(formattedColumns);
				settableData(res.data.data);
			})
			.catch((error) => console.error("Error fetching subcategories:", error));
		}
	}, [subcat]);


	  const handleCategoryChange = (event) => {
		const categoryId = event.target.value;
		setSelectedCategory(categoryId)	 
		if (categoryId === "") {
			setSubcategories([]); // Reset subcategories
			settableData([]); // Clear DataTable
			return;
		}
		   axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('pmis_predefined_reports'), cols: strEncode("*") ,  whrc:strEncode("c_type = '"+categoryId+"'")}) 
			.then((response) => setSubcategories(response.data))
		  .catch((error) => console.error("Error fetching subcategories:", error));
		  
	  };

	  const exportData = (type) => {
		const ws = XLSX.utils.json_to_sheet(tabledata);
		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
	
		if (type === "csv") {
		  XLSX.writeFile(wb, "data_export.csv");
		} else {
		  XLSX.writeFile(wb, "data_export.xlsx");
		}
	  };

	  const handleSubCategoryChange = (event) => {
		     const subcategoryId = event.target.value;		
			 axios.post(`${API_BASE_URL}/api/custom/selectall`, {
				t: strEncode('pmis_predefined_reports'),
				cols: strEncode("*"),
				whrc: strEncode(`id = '${subcategoryId}'`)
			})
			.then((response) => {
				setSubCat(response.data[0].c_sql);
			
			})
			.then((res) => {	
			})
			.catch((error) => console.error("Error fetching subcategories:", error));
	  };

	  
	   
	  
	
	return (
		<div>
			<ol className="breadcrumb float-xl-end">
				<li className="breadcrumb-item"><Link to="/dashboard/v1">الصفحة الرئيسية</Link></li>
				<li className="breadcrumb-item"><Link to="/dashboard/blank">التقرير</Link></li>
				<li className="breadcrumb-item active">قائمة التقارير</li>
			</ol>
			<h1 className="page-header">قائمة التقارير</h1>
			<Panel>
				<PanelHeader>التقارير المحددة مسبقًا: حدد نوع التقرير والتقرير الذي تريد تحميله وتصديره
</PanelHeader>
				<PanelBody>
				<div className="col-xl-12">
				<form id="smart-form-register" className="smart-form" noValidate>
					<div className="row col-md-12">
				<div className="col-md-6 form-group" style={{ margin: "5px" }}>
				    	<label class="input">حدد نوع التقرير :</label>
						<select onChange={handleCategoryChange} value={selectedCategory}>
							<option value="">اختر الفئة</option>
							{categories.map((cat) => (
							<option key={cat.type} value={cat.type}>{cat.type}</option>
							))}
						</select>
                 </div>
				 <div className="col-md-6 form-group" style={{ margin: "5px" }}>
						<label class="input">حدد التقرير : </label>
						<select  onChange={handleSubCategoryChange} disabled={!selectedCategory}>
							<option value="">حدد الفئة الفرعية</option>
							{subcategories.map((sub) => (
							<option key={sub.id} value={sub.id}>{sub.c_name}</option>
							))}
						</select>
						</div>
						</div>
						 </form>

						<div>
								<button onClick={() => exportData("xlsx")} className="btn btn-success">
								تصدير إلى إكسل
								</button>
							<DataTable
									title="بيانات التقرير"
									columns={columns}
									data={tabledata}
									pagination
									highlightOnHover
								/>
						</div>
						
			
				</div>
					
				</PanelBody>
			</Panel>
			
		</div>
	)
}

export default Predefined;